<template>
  <div>
    <v-dialog v-model="assigncarddialog" persistent width="900px">
      <v-card class="overflow-hidden">
        <v-toolbar dark class="header" dense>
          <v-icon>mdi-account-circle</v-icon>
          <span class="ml-3"> Create Card User</span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="assignCardClose()">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step color="green" :complete="e1 > 1" step="1"
              >Assign Card</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step color="green" :complete="e1 > 2" step="2"
              >Expense Approver</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step color="green" :complete="e1 > 3" step="3"
              >Budget</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step color="green" :complete="e1 > 4" step="4"
              >Card Master</v-stepper-step
            >
            <v-divider></v-divider>

            <v-stepper-step color="green" :complete="e1 > 5" step="5"
              >Preview</v-stepper-step
            >
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="assignCards">
                <!-- <v-row v-if="ispersonalized == true">
                  <v-col cols="12" md="12" sm="3">
                    <v-text-field
                      label="Proxy Number"
                      v-model="proxynumber"
                      disabled
                      readonly
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <v-row class="mt-3 mb-n7">
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    class="mt-n5"
                  >
                    <!-- <v-combobox
                      v-if="kyc == true"
                      v-model="selectPayee"
                      :items="empitems"
                      label="Select Employee"
                      item-text="full_name"
                      @input="getEmail()"
                      dense
                      outlined
                    ></v-combobox> -->
                    <v-text-field
                      v-model="selectPayee"
                      label="First Name *"
                      dense
                      outlined
                      :rules="[(v) => !!v || 'Required']"
                      v-on:keypress="isLetter($event)"
                      @keydown.space="preventLeadingSpace"
                      maxlength="80"
                    ></v-text-field>
                    <!-- <v-autocomplete
                      label="Select a payee"
                      cache-items
                      v-model="selectPayee"
                      :items="empitems"
                      item-text="full_name"
                      @input="getEmail()"
                      :search-input.sync="cSearch"
                      dense
                      hide-no-data
                      hide-details
                      outlined
                    ></v-autocomplete>-->
                    <!-- <v-text-field label="Select a payee" v-model="selectPayee" dense outlined></v-text-field> -->
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    class="mt-n5"
                  >
                    <v-text-field
                      v-model="selectPayee1"
                      label="Middle Name "
                      dense
                      outlined
                      v-on:keypress="isLetter($event)"
                      maxlength="80"
                      @keydown.space="preventLeadingSpace"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    class="mt-n5"
                  >
                    <v-text-field
                      v-model="selectPayee2"
                      label="Last Name *"
                      dense
                      outlined
                      v-on:keypress="isLetter($event)"
                      maxlength="80"
                      @keydown.space="preventLeadingSpace"
                      :rules="[(v) => !!v || 'Required']"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="2"
                    md="2"
                    xl="2"
                    class="mt-n5"
                  >
                    <v-text-field
                      disabled
                      placeholder="+60"
                      v-model="CountryCode"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="4"
                    md="4"
                    xl="4"
                    class="mt-n5"
                  >
                    <v-text-field
                      label="Contact Number *"
                      v-model="ContactNumber"
                      maxlength="10"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                                    /^[1-9][0-9]*$/.test(v) ||
                                    'Invalid Contact Number',
                        (v) => (v && v.length < 11) || 'Invalid Contact Number',
                        (v) => (v && v.length > 8) || 'Invalid Contact Number',
                      ]"
                      dense
                      outlined
                      @keydown.space="preventLeadingSpace"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    class="mt-n5"
                  >
                    <v-text-field
                      label="E-mail *"
                      v-model="email_id"
                      :rules="[rules1.required, rules1.email]"
                      dense
                      outlined
                      @keydown.space="preventLeadingSpace"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    class="mt-n5"
                  >
                    <v-text-field
                      label="Designation"
                      v-model="Designation"
                      maxlength="80"
                      v-on:keypress="isLetter($event)"
                      dense
                      outlined
                      @keydown.space="preventLeadingSpace"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[
                        (v) => !!v || 'Required',
                        (v) => (v && v.length >= 3) || 'Minimum 3 characters',
                        (v) =>
                          v.length <= 40 ||
                          'Name must be less than 40 characters',
                      ]" -->
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    class="mt-n5"
                  >
                    <v-select
                      v-model="userTypeDestn"
                      color="primary"
                      :items="userTypelist"
                      item-text="usetTypeFN"
                      item-value="ut_id"
                      label="User Type"
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="
                    continueSecondStep();
                    geApprovalLis1();
                  "
                  >Continue</v-btn
                >
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-form ref="assignCards2">
                <v-row class>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    justify="center"
                    align="center"
                    class="mt-1"
                  >
                    <v-select
                      label="Approver 1 *"
                      item-text="name"
                      :rules="[(v) => !!v || 'Required']"
                      item-value="user_id"
                      v-model="approverv"
                      :items="approvalList"
                      return-object
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="6" class="mt-n8 ml-1">
                    <h4
                      v-if="approverv != ''"
                      color="primary"
                      class="primary--text"
                    >
                      Department : {{ approverv.department_name }}
                    </h4>
                  </v-col> -->
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    justify="center"
                    align="center"
                    class="mt-1"
                  >
                    <v-select
                      justify="center"
                      align="center"
                      label="Approver 2 *"
                      item-text="name"
                      :rules="nameRules"
                      item-value="user_id"
                      v-model="approverv2"
                      :items="approvalList2"
                      return-object
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="e1 = 1">back</v-btn>
                <v-btn color="primary" @click="callBudget()">Continue</v-btn>
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-form ref="assignCards3">
                <v-row class>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    justify="center"
                    align="center"
                    class="mt-1"
                  >
                    <v-select
                      :rules="[(v) => !!v || 'Required']"
                      label="Department Name *"
                      v-model="Department"
                      :items="departmrnts"
                      item-text="department_name"
                      item-value="department_id"
                      @click="getDepartList"
                      @input="getbudget"
                      return-object
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="2">
                  <v-tooltip bottom color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-chip class="mt-2" color="secondary" label text-color="primary">
                        <v-icon small class="mr-3" v-on="on" color="white">mdi-information</v-icon>500 RM
                      </v-chip>
                    </template>
                    <span>Available Department Balance</span>
                  </v-tooltip>
                  </v-col>-->
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    lg="6"
                    md="6"
                    xl="6"
                    justify="center"
                    align="center"
                    class="mt-1"
                  >
                    <v-text-field
                      v-model="income_amount"
                      label="Assign Budget(MYR)"
                      item-value="department_id"
                      outlined
                      dense
                      :hint="assignamt"
                      :color="redcolor"
                      :error="error"
                      required
                      maxlength="10"
                      :disabled="totaldepartment_budget == 0"
                      @keypress="isNumber(event)"
                    ></v-text-field>
                  </v-col>

                  <v-form ref="lay1">
                    <v-card
                      :width="isMobile ? '300' : '850'"
                      elevation="1"
                      class="mb-5 ml-2 mr-2"
                      rounded="xl"
                      v-if="budget_check == true"
                    >
                      <v-row>
                        <v-col cols="12" lg="6" xl="6" md="6" sm="12" xs="12">
                          <span class="primary--text Heading 6 ml-4"
                            >Department Budget
                          </span>
                        </v-col>

                        <v-col cols="12" lg="6" xl="6" md="6" sm="12" xs="12">
                          <span
                            class="green--text ml-4 Heading 6"
                            style="
                              font-style: italic;
                              font-family: Times New Roman;
                            "
                          >
                            <b class="primary--text"
                              >Click here to allocate Department Budget :</b
                            >
                          </span>
                          <v-btn
                            v-if="
                              budget_check == true &&
                              totaldepartment_budget == 0
                            "
                            fab
                            dark
                            small
                            color="primary"
                            text
                            @click="allocate()"
                          >
                            <v-icon dark> mdi-plus </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
                          <!-- <br /> -->
                          <span class="ml-4 green--text Heading-1">
                            <b class="primary--text">Total Budget :</b>
                            {{ totaldepartment_budget }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
                          <span class="green--text ml-4 Heading 6">
                            <b class="primary--text">Allocated Budget :</b>
                            {{ allocated_amount }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
                          <span class="green--text ml-4 Heading 6">
                            <b class="primary--text">Unallocated Budget :</b>
                            {{ unallocated_amount }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-row
                      class="ml-3 mt-2"
                      v-if="budget_check == true && totaldepartment_budget != 0"
                    >
                      <span class="primary--text"
                        >* Allocate the Budget within Unallocated Budget
                      </span>
                    </v-row>
                    <v-row
                      class="ml-3 mt-2"
                      v-if="budget_check == true && totaldepartment_budget == 0"
                    >
                      <span class="red--text">
                        Allocate Department Budget before assiging the User
                        Budget
                      </span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-form>
                </v-row>
              </v-form>
              <v-card-actions class="mt-8">
                <v-spacer />
                <v-btn color="primary" text @click="e1 = 2">back</v-btn>
                <v-btn color="primary" @click="callNextEl4()">Continue</v-btn>
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-form ref="assignCards4">
                <v-row class="ml-1">
                  <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                    <v-radio-group v-model="cardrow" row>
                      <div class="primary--text font-weight-medium text">
                        Choose card type :
                      </div>

                      <v-radio
                        class="ml-3"
                        label="Physical Card"
                        value="1"
                      ></v-radio>
                      <v-radio
                        label="Virtual Card"
                        value="2"
                        class="ml-3"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    lg="6"
                    xl="6"
                    md="6"
                    sm="12"
                    xs="12"
                    class="mt-2"
                  >
                    <v-select
                      label="Choose Card Type *"
                      v-model="selectExpense"
                      :items="itemCards"
                      @input="getExpenseCard(selectExpense)"
                      dense
                      :rules="[(v) => !!v || 'Required']"
                      return-object
                      outlined
                      :class="
                        this.is_master == 0 ? 'grey--text' : 'primary--text'
                      "
                    ></v-select>
                  </v-col>

                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    md="12"
                    sm="12"
                    xs="12"
                    v-if="viewCard == true"
                    class="mt-n4 ml-n10"
                  >
                    <v-card
                      class="ml-11"
                      elevation="4"
                      :width="isMobile ? '300' : '620'"
                    >
                      <v-card-actions>
                        <v-spacer />
                        <v-icon
                          color="red"
                          class="ml-n3 mt-n1"
                          medium
                          @click="viewCard = false"
                          >mdi-close-circle</v-icon
                        >
                      </v-card-actions>
                      <v-card-text class="mt-n10">
                        <v-form ref="formCat" v-model="valid1" lazy-validation>
                          <v-row layout align="center" justify="center">
                            <v-col cols="12">
                              <div>
                                <span class="subtitle-2">
                                  <b class="primary--text">Card Type:</b>
                                  {{ cardname }}
                                </span>
                                <br />
                                <span class="subtitle-2">
                                  <b class="primary--text">Type Description:</b>
                                  {{ typedescription }}
                                </span>
                                <br />
                              </div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6" class="mt-0">
                              <div>
                                <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Allow at all Merchants:</b
                                  >
                                  <v-icon
                                    v-if="iconvalue2 == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >

                                  <v-icon
                                    v-if="iconvalue2 == 0"
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                </span>

                                <br />
                                <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Allow ATM Transactions :</b
                                  >
                                  <!-- <v-icon color="red" medium v-if="proxyStastus==1">mdi-close-circle</v-icon> -->
                                  <v-icon
                                    v-if="iconvalue == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    color="red"
                                    v-if="iconvalue == 0"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                                <br />
                                <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Allow at selected Merchants:</b
                                  >
                                  <v-icon
                                    v-if="
                                      iconvalue4 == 1 || carddisplay != null
                                    "
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >

                                  <v-icon
                                    v-if="
                                      iconvalue4 == 0 || carddisplay == null
                                    "
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                                <br />
                                <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Country - Only Malaysia :</b
                                  >
                                  <v-icon
                                    v-if="iconvalue9 == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    v-if="iconvalue9 == 0"
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                  <!-- mdi-close-thick -->
                                </span>
                                <br />
                                <!-- v-show="iconvalue2 == 1" -->
                                <span
                                  v-for="(mcc, idx) in newmccitems"
                                  :key="idx"
                                >
                                  <v-card outlined class="mt-1">
                                    <li class="ml-5 primary--text">
                                      {{ mcc }}
                                    </li>
                                  </v-card>
                                </span>
                              </div>
                            </v-col>

                            <v-col cols="6" class="mt-0">
                              <div>
                                <span class="subtitle-2">
                                  <b class="primary--text">Allow E-Commerce:</b>
                                  <v-icon
                                    v-if="iconvalue6 == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    v-if="iconvalue6 == 0"
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                                <br />
                                <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Allow Shopping with Pin:</b
                                  >
                                  <v-icon
                                    v-if="iconvalue3 == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    v-if="iconvalue3 == 0"
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                  <!-- mdi-close-thick -->
                                </span>
                                <br />
                                <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Allow Contactless Shopping :</b
                                  >
                                  <v-icon
                                    v-if="iconvalue5 == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    v-if="iconvalue5 == 0"
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                  <!-- mdi-close-thick -->
                                </span>
                                <br />

                                <!-- <span class="subtitle-2">
                                  <b class="primary--text"
                                    >Allow Ecommerce Non 3DS:</b
                                  >
                                  <v-icon
                                    v-if="iconvalue7 == 1"
                                    color="green"
                                    medium
                                    >mdi-check-bold</v-icon
                                  >
                                  <v-icon
                                    v-if="iconvalue7 == 0"
                                    color="red"
                                    medium
                                    >mdi-close-thick</v-icon
                                  >
                                </span> -->
                                <br />
                                <!-- v-show="iconvalue7 == 0" -->

                                <br />
                              </div>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    lg="6"
                    xl="6"
                    md="6"
                    sm="12"
                    xs="12"
                    class="mt-n1 ml-1"
                  >
                    <v-textarea
                      label="Comment *"
                      v-model="comments"
                      auto-grow
                      :rules="[(v) => !!v || 'Required']"
                      outlined
                      rows="1"
                      row-height="15"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="e1 = 3">back</v-btn>
                <v-btn color="primary" @click="Continue()">Continue</v-btn>
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content step="5">
              <v-card class="elevation-6">
                <v-row>
                  <v-col cols="12">
                    <div>
                      <span class="title primary--text"><b>Assign Card</b></span
                      ><br /><br />
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="selectPayee"
                            label="First Name "
                            dense
                            outlined
                            readonly
                          ></v-text-field
                        ></v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="selectPayee1"
                            label="Middle Name "
                            dense
                            outlined
                            readonly
                          ></v-text-field
                        ></v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="selectPayee2"
                            label="Last Name "
                            dense
                            outlined
                            readonly
                          ></v-text-field
                        ></v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            label="Contact Number"
                            v-model="ContactNumber"
                            maxlength="10"
                            readonly
                            dense
                            outlined
                          ></v-text-field
                        ></v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            label="E-mail"
                            v-model="email_id"
                            readonly
                            dense
                            outlined
                          ></v-text-field
                        ></v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            label="Designation"
                            v-model="Designation"
                            readonly
                            dense
                            outlined
                          ></v-text-field
                        ></v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="userTypeDestn"
                            color="primary"
                            :items="userTypelist"
                            item-text="usetTypeFN"
                            item-value="ut_id"
                            label="User Type"
                            outlined
                            readonly
                            dense
                          ></v-select
                        ></v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card flat>
                <v-row>
                  <v-col cols="12">
                    <div>
                      <span class="title primary--text">
                        <b>Expense Approver</b></span
                      ><br /><br />
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                            justify="center"
                            align="center"
                            label="Approver 1"
                            item-text="name"
                            item-value="user_id"
                            v-model="approverv"
                            :items="approvalList"
                            return-object
                            dense
                            readonly
                            outlined
                          ></v-select
                        ></v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            justify="center"
                            align="center"
                            label="Approver 2"
                            item-text="name"
                            item-value="user_id"
                            v-model="approverv2"
                            :items="approvalList2"
                            return-object
                            dense
                            readonly
                            outlined
                          ></v-select
                        ></v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card flat>
                <v-form ref="form3">
                  <v-row>
                    <v-col cols="12">
                      <div>
                        <span class="title primary--text"> <b>Budget</b></span
                        ><br /><br />
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-select
                              :rules="rules1.required"
                              label="Department Name"
                              v-model="Department"
                              :items="departmrnts"
                              item-text="department_name"
                              item-value="department_id"
                              @click="getDepartList"
                              @input="getbudget"
                              return-object
                              dense
                              readonly
                              outlined
                            ></v-select
                          ></v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="income_amount"
                              label="Assign Budget(MYR)"
                              item-value="dep_budget_id"
                              outlined
                              dense
                              readonly
                              required
                              @keypress="isNumber(event)"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
              <v-card flat>
                <v-row>
                  <v-col cols="12">
                    <div>
                      <span class="title primary--text"><b>Card Master</b></span
                      ><br /><br />
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-select
                            label="Select Card Type"
                            v-model="selectExpense"
                            :items="itemCards"
                            @input="getExpenseCard(selectExpense)"
                            dense
                            readonly
                            return-object
                            outlined
                          ></v-select
                        ></v-col>
                        <v-col cols="12" md="8" sm="12" xs="12" xl="8">
                          <v-radio-group v-model="cardrow" row disabled>
                            <div class="primary--text font-weight-medium text">
                              Choosed Card Type :
                            </div>

                            <v-radio
                              class="ml-6"
                              label="Physical Card"
                              value="1"
                            ></v-radio>
                            <v-radio
                              label="Virtual Card"
                              class="ml-6"
                              value="2"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea
                            label="Comment"
                            v-model="comments"
                            auto-grow
                            readonly
                            outlined
                            rows="1"
                            row-height="10"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="e1 = 4">back</v-btn>
                <v-btn color="primary" @click="assignopendialog()"
                  >Assign</v-btn
                >
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assigndialog" width="400" persistent>
      <v-card class="overflow-hidden">
        <v-toolbar class="elevation-0" dense>
          <span> Are you sure you want to submit ? </span>
          <v-spacer></v-spacer>
          <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
        </v-toolbar>
        <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-row class="mt-2" style="margin-left: 200px">
            <v-btn
              text
              width="90px"
              class="mb-4 red--text"
              @click="assigndialog = false"
              >Back</v-btn
            >
            <v-btn
              text
              width="90px"
              class="mb-4 primary--text"
              @click="assigncardtombr()"
              >Submit</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog persistent v-model="createCard" width="600">
      <v-card class="elevation-0">
        <v-toolbar dark color="primary" class="elevation-0" dense>
          <v-toolbar-title>Create Card Type Master</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="closecreatecard()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text>
          <v-form ref="formCat1" v-model="valid" lazy-validation>
            <v-row layout align="center" justify="center">
              <v-row class="ml-3 mt-2">
            

                <v-radio-group v-model="cardrow" row>
                  <div class="primary--text font-weight-medium text">
                    Choose Card Type :
                  </div>
                  <v-radio
                    class="ml-6"
                    label="Physical Card"
                    value="1"
                    :rules="[(v) => !!v || 'Required']"
                  ></v-radio>
                  <v-radio
                    label="Virtual Card"
                    value="2"
                    :rules="[(v) => !!v || 'Required']"
                  ></v-radio>
                </v-radio-group>
             
              </v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  outlined
                  v-model="createName"
                  label="Card Type "
                  maxlength="20"
                  :rules="[(v) => !!v || 'Required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-n4">
                <v-text-field
                  dense
                  outlined
                  v-model="createDescription"
                  label="Type  Description"
                  maxlength="50"
                  :rules="[(v) => !!v || 'Required']"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  v-model="checkbox1"
                  label="Allow ATM"
                  class="mt-n3"
                ></v-checkbox>
                <v-checkbox
                  v-model="checkbox2"
                  label="Allow POS"
                  class="mt-n3"
                ></v-checkbox>
                <v-checkbox
                  v-model="checkbox6"
                  label="Allow Without Pin "
                  class="mt-n3"
                ></v-checkbox>
        
                <v-checkbox
                  v-model="checkbox8"
                  label="Allow All MCC"
                  class="mt-n3"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" class="mt-n1">
                <v-checkbox
                  v-model="checkbox5"
                  label="Allow Ecommerce 3DS"
                  class="mt-n3"
                ></v-checkbox>
                <v-checkbox
                  v-model="checkbox7"
                  label="Allow Ecommerce Non 3DS"
                  class="mt-n3"
                ></v-checkbox>
  
                <v-checkbox
                  v-model="checkbox4"
                  label="Allow Few MCC"
                  class="mt-n3"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row
              layout
              class="pa-2 mt-n7"
              align="center"
              justify="center"
              v-if="checkbox4"
            >
              <v-select
                v-model="e7"
                :items="mccitems"
                label="Select"
                multiple
                item-value="code"
                item-text="text"
                outlined
                chips
                hint="Merchant category Codes(MCC)"
                persistent-hint
              ></v-select>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="mr-7 mt-n2">
          <div class="flex-grow-1"></div>
          <v-btn
            rounded
            width="90px"
            dark
            class="mb-4 primary white--text"
          @click="createCardtypemaster"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    nameRules: [(v) => !!v || "Required"],

    rules1: {
      required: (value) => !!value || "Required",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: (value) => value.length <= 100 || "Max 100 characters",
    },
    income_amount: "",
    userTypeDestn: "",
    unallocated_amount: "",
    userTypelist: [],
    assigndialog: false,
    catcodenames: [],
    userType: "",
    allocated_amount: "",
    e7: [],
    kyc: true,
    cSearch: null,
    viewCard: false,
    createCard: false,

    mcctext: "",
    mccitems: [],
    totaldepartment_budget: "",
    budget_check: false,
    iconvalue: "",
    itemCards: [
      // {
      //   cardName: "ATM Card",
      //   description: "Can only withdraw cash from ATM",
      //   craeted_on: "20-01-2021",
      // },
      // {
      //   cardName: "Petrol Card",
      //   description: "Can only fill up petrol from pumps",
      //   craeted_on: "20-01-2021",
      // },
      // {
      //   cardName: "Sales Card",
      //   description: "Only travel and F&B",
      //   craeted_on: "20-01-2021",
      // },
      // {
      //   cardName: "Online Card",
      //   description: "Allows only online shopping",
      //   craeted_on: "20-01-2021",
      // },
    ],

    newField: "",
    budget_amt: "",
    redcolor: "",
    error: false,
    carddisplay: [],
    selectExpense: "",
    selectPayee: null,
    selectPayee1: "",
    selectPayee2: "",
    comments: "",
    empitems: [],
    catname: "",
    cardtypes: ["Physical Card", "Virtual Card"],
    checkbox1: false,
    checkbox2: false,
    is_director1: "",
    is_master: "",
    checkbox3: false,
    checkbox6: false,
    checkbox7: false,
    checkbox8: false,
    checkbox4: false,
    checkbox5: false,
    e1: 4,
    Department: "",
    assigncarddialog: false,
    departmrnts: [],
    // approverlist: [],
    approverv: "",
    approverv2: "",
    proxynumber: null,
    cardrow: "1",

    FName: "",
    MName: "",
    LName: "",
    Budget: "",
    email_id: "",
    ContactNumber: "",
    CountryCode: "",
    ispersonalized: "",
    Duration: "",
    Durations: ["Daily", "Monthly", "Weekly"],
    Designation: "",
    status: "",
    cardtypemaster: "",
    search: "",
    on: "",

    rules: {
      //step 1 rules
      title: [(v) => !!v || "Required"],
      email: [
        (v) =>
          /^(?:[\w]+@([\w]+\.)+[a-zA-Z]+)?$/.test(v) || "E-mail must be valid",
      ],
    },
    createName: "",
    checkreadonly: "",
    newmccitems: [],
    viewName: "",
    valid: false,
    valid1: false,
    createDescription: "",
    approvalList: [],
    approvalList2: [],
    somevalue: "",
    hideSnackar: false,
    assignamt: "",
  }),
  watch: {
    Department(val) {
      if (val != null && this.totaldepartment_budget != 0) {
        // this.budget_amt = `Enter Amount`;
        // this.redcolor = "red";
        // this.error = true;
      }
    },
    income_amount(val) {
      // console.log(val);
      if (val > Number(this.unallocated_amount)) {
        this.assignamt = `Enter Amount less than ${this.unallocated_amount}`;
        this.redcolor = "red";
        this.error = true;
      } else {
        //  console.log("true");
        this.assignamt = ``;
        this.redcolor = "";
        this.error = false;
      }
    },
    cardrow(val) {
      // console.log( val);
      if (val == "1") {
        this.viewCard = false;
        this.selectExpense = "";
        this.cardtypemaster = "1";

        // this.$refs.assignCards4.resetValidation();

        this.gctmasterapi();
      } else if (val == "2") {
        this.viewCard = false;
        this.selectExpense = "";
        this.cardtypemaster = "2";
        this.gctmasterapi();
        // this.$refs.assignCards4.resetValidation();
      }
    },
    checkbox8(val) {
      if (val == true) {
        this.e7 = [];
        this.checkbox4 = false;
      }
    },
    checkbox4(val) {
      if (val == true) {
        this.checkbox8 = false;
      }
    },
  },
  mounted() {
    // if(this.cardrow==1){
    //   console.log("Value is 1")
    //   //  this.gctmasterapi();
    // }
    this.userTypeList();
  },
  created() {
    // this.corponboard();
    this.getDepartList();
    // this.getEmpDetails();

    this.getCatDetails();
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    allocate() {
      this.$router.push("/Budget");
    },
    cardtypemasterlink() {
      this.$store.commit("SET_dialogcheck", true);
      this.$router.push("/CardTypeMaster");
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Z a-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    callNextEl4() {
      if (this.Department != "") {
        this.e1 = 4;
        this.gctmasterapi();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Department name required",
          color: "red",
        });
        // this.gctmasterapi();
      }
    },

    assignopendialog() {
      this.assigndialog = true;
    },
    callBudget() {
      if (this.$refs.assignCards2.validate()) {
        this.e1 = 3;
      }
    },

    Continue() {
      if (this.$refs.assignCards4.validate()) {
        this.e1 = 5;
      }
    },

    async gctmasterapi() {
      this.overlay = true;
      this.itemCards = [];
      var inputData = {
        method_name: "ADMINSET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "GCTMASTER",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
          sub_card_type: this.cardtypemaster == "" ? 1 : this.cardtypemaster,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log(
      //   responseData.data.data[0].group_details.group_name,
      //   "responseData"
      // );
      // this.newmcc =
      //   responseData.data.data == null ? [] : responseData.data.data;
      // console.log(" this.newmcc", this.newmcc);
      // for (let i = 0; i < this.newmcc.length; i++) {
      //   if (this.newmcc[i].card_name == this.selectExpense) {
      //     this.mcctext = this.newmcc[i].group_details.group_name;
      //   }
      //  this.newmcc[i].group_name = this.newmcc[i].group_details.group_name;
      //   console.log("    mcctext", this.mcctext);
      // }

      if (responseData.data.status == "00") {
        var self = this;

        for (let i = 0; i < responseData.data.data.length; i++) {
          this.is_master = responseData.data.data[i].ismaster;
          //  console.log(this.is_master, "ismaster");
        }
        responseData.data.data.forEach(function (ele) {
          //console.log(ele, "ele");
          self.itemCards.push({
            text: ele.card_name,
            value: ele,
          });
        });
        // this.newmcc=  responseData.data.data
        //console.log("itemCards", self.itemCards);
        //     var itemname = [];

        // for (let i = 0; i < self.itemCards.length; i++) {
        //   itemname.push(self.itemCard.value);
        // }
        //   console.log("itemname",itemname)

        this.overlay = false;
      } else {
        this.overlay = false;
      }
    },
    //     varifyradio(){
    // if (this.cardrow == "1" || this.cardrow == "2") {
    // this.createCardtypemaster();
    // }
    //      else{    this.$store.commit("snackbar/showMessage", {
    //             content: "Please select card type",
    //             color: "red",
    //           });
    // }
    //     },
    async createCardtypemaster() {
      //console.log(this.e7);`

      var catIds = [];
      //var self = this;
      this.e7.forEach(function (ele) {
        catIds.push({
          value: ele,
        });
      });
      // end

      //to get matched objects from the list mccitems according to selected ids
      let matchedIdObj = this.mccitems.filter((o1) =>
        catIds.some((o2) => o1.value === o2.value)
      );
      //end

      //to fetch array of codes of the selected category
      var catCodeArray = [];
      matchedIdObj.forEach(function (obj) {
        catCodeArray.push(obj.code);
      });
      //end
      if (this.$refs.formCat1.validate()) {
        var inputData1 = {
          method_name: "ADMINSET",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "APORTAL",
          method_param: {
            action: "CRDMASTER",
            cat_code: catCodeArray,
            card_name: this.createName,
            has_atm: this.checkbox1 == true ? 1 : 0,
            has_pos: this.checkbox2 == true ? 1 : 0,
            has_ecommerce: this.checkbox5 == true ? 1 : 0,
            has_few_mcc: this.checkbox4 == true ? 1 : 0,
            has_mcc: this.checkbox8 == true ? 1 : 0,
            has_ecommerce_3ds: this.checkbox5 == true ? 1 : 0,
            has_ecommerce_non_3ds: this.checkbox7 == true ? 1 : 0,
            is_master: "0",
            card_description: this.createDescription,
            corp_id: this.$store.getters.get_corpid,
            group_id: this.e7,
            sub_card_type: this.cardtypemaster == "" ? 1 : this.cardtypemaster,
            // mcc_values: this.e7,
            // search_text: "",
            // corp_id: 0,
          },
        };
        var responseData1 = await apiCall(inputData1);
        // console.log("responseData CRDMASTER ", responseData);

        if (responseData1.data.status == "00") {
          this.$refs.formCat1.resetValidation();
          // this.$refs.formCat1.reset();
          this.createCard = false;

          this.$store.commit("snackbar/showMessage", {
            content: "Created successfully",
            color: "green",
          });
          this.gctmasterapi();
          (this.createName = ""),
            (this.createDescription = ""),
            (this.checkbox1 = false),
            (this.checkbox2 = false),
            (this.checkbox5 = false),
            (this.checkbox4 = false),
            (this.checkbox6 = false),
            (this.checkbox7 = false),
            (this.checkbox8 = false),
            (this.e7 = []);
          // console.log("e7", this.e7);
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: "Card type already exist",
            color: "red",
          });
        }
      }
    },

    getbudget() {
      // console.log(this.Department);
      this.totaldepartment_budget = this.Department.total_budget;
      this.allocated_amount = this.Department.allocated_budget;
      this.unallocated_amount = this.Department.unallocated_budget;
      this.budget_check = true;
    },
    async getCatDetails() {
      var inputData = {
        method_name: "ADMINSET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "GETCATGRP",
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("gvg", responseData.data.data);
      if (responseData.data.status == "00") {
        var self = this;
        responseData.data.data.forEach(function (ele) {
          self.mccitems.push({
            text: ele.group_name,
            value: ele.group_id,
            code: ele.group_id,
          });
          // console.log("ele.cat_code", ele.cat_code);
        });
        //console.log("dddddddd", self.mccitems);
      } else {
        this.itemsCategary = [];
      }
    },
    async geApprovalLis1() {
      // alert(20);
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXPCHECK",
          corp_id: this.$store.getters.get_corpid, // "16", //"4",
          type: "1",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("geApprovalLis", responseData);
      var arrayapproval = [];
      this.approvalList = responseData.data.data;
      responseData.data.data.forEach(function (ele) {
        arrayapproval.push({
          name:
            ele.name +
            "(" +
            "Dept.name" +
            " " +
            ":" +
            " " +
            " " +
            ele.department_name +
            ")",
          department_name: ele.department_name,
          user_id: ele.user_id,
        });
      });
      this.approvalList = arrayapproval;
      // console.log(" this.approvalList", this.approvalList);
      this.geApprovalLis2();
    },
    async geApprovalLis2() {
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXPCHECK",
          corp_id: this.$store.getters.get_corpid, // "16", //"4",
          type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("geApprovalLis", responseData);
      var arrayapproval2 = [];
      this.approvalList2 = responseData.data.data;
      responseData.data.data.forEach(function (ele) {
        arrayapproval2.push({
          name:
            ele.name +
            "(" +
            "Dept.name" +
            " " +
            ":" +
            " " +
            " " +
            ele.department_name +
            ")",
          department_name: ele.department_name,
          user_id: ele.user_id,
        });
      });
      this.approvalList2 = arrayapproval2;
      // console.log("arrayapproval2", arrayapproval2);
    },
    closecreatecard() {
      this.createCard = false;
      this.createName = "";
      (this.createDescription = ""),
        (this.checkbox1 = ""),
        (this.checkbox2 = ""),
        (this.checkbox3 = ""),
        (this.checkbox4 = ""),
        (this.checkbox5 = ""),
        (this.checkbox6 = ""),
        (this.checkbox7 = ""),
        (this.checkbox8 = ""),
        // this.$refs.formCat1.reset();
        (this.e7 = "");
      this.$refs.formCat1.resetValidation();
    },

    async corponboard() {
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "FCINFO",
          corp_id: this.$store.getters.get_corpid, // "16", //"4",
        },
      };
      var responseData = await apiCall(inputData);
      //    console.log("localinputDagta", responseData.data.data);
      // responseData.data.data[0].kyc_status = 1;
      if (responseData.data.data.kyc_status == 0) {
        // alert(20);
        this.kyc = false;
        this.selectPayee = responseData.data.data.fname;
        this.selectPayee1 = responseData.data.data.mname;
        this.selectPayee2 = responseData.data.data.lname;
        this.email_id = responseData.data.data.email_id;
        this.ContactNumber = responseData.data.data.mobileno;

        this.Designation = responseData.data.data.designation;
      }
    },
    async userTypeList() {
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GCUSRTP",
          corp_id: this.$store.getters.get_corpid, //"3",
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      //   console.log("userTypelist", responseData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var res = responseData.data.data;
          res.forEach((element) => {
            this.userTypelist.push({
              usetTypeFN:
                element.ut_name +
                " - (" +
                element.role_name +
                "/" +
                element.grade_name +
                "/" +
                element.loc_name +
                ")",
              ut_id: element.ut_id,
            });
          });
        }
        //    console.log("fff", this.userTypelist);
      } else {
        this.userTypelist = [];
      }
    },
    assignCardClose() {
      this.$refs.assignCards.reset();
      this.$refs.assignCards2.reset();
      this.$refs.assignCards3.reset();
      // this.$refs.assignCards4.reset();
      this.$refs.assignCards2.resetValidation();
      this.$refs.assignCards3.resetValidation();
      this.$refs.assignCards4.resetValidation();
      this.$refs.assignCards.resetValidation();
      (this.comments = ""), (this.budget_check = false);
      this.viewCard = false;

      // this.$refs.lay1.reset();
      // this.$refs.formCat.reset();
      // this.$refs.lay1.resetValidation();
      // this.$refs.formCat.resetValidation();
      this.assigncarddialog = false;
    },
    continueSecondStep() {
      if (this.$refs.assignCards.validate()) {
        this.e1 = 2;
      }
    },
    getEmail() {
      //  console.log("mmm", this.selectPayee.email_id);
      this.email = this.selectPayee.email_id;
    },
    getExpenseCard(item) {
      // console.log("iteeeeeemm",item.value.group_details)

      this.viewCard = true;
      var newmcc = [];
      this.carddisplay = item.value.group_details;
      if (item.value.group_details != null) {
        for (let i = 0; i < item.value.group_details.length; i++) {
          newmcc.push(item.value.group_details[i]);
        }
      }
      // console.log("gggggg", newmcc);
      this.newmccitems = [];
      for (let i = 0; i < newmcc.length; i++) {
        this.newmccitems.push(newmcc[i].group_name);
      }

      // console.log("valueeeee", this.newmccitems);

      this.cardname = item.value.card_name;
      this.cardcardmaster_id = item.value.cardmaster_id;
      this.ysechargecode = item.value.yse_charge_code;
      this.typedescription = item.value.description;
      this.iconvalue = item.value.has_atm;
      this.iconvalue1 = item.value.has_ecommerce;
      this.iconvalue2 = item.value.has_mcc;
      this.iconvalue4 = item.value.has_few_mcc;
      //this.catcodenames = item.value.cat_id;
      this.iconvalue3 = item.value.has_pos;
      this.iconvalue5 = item.value.has_without_pin;
      this.iconvalue6 = item.value.has_ecommerce_3ds;
      this.iconvalue7 = item.value.has_ecommerce_non_3ds;
      this.iconvalue9 = item.value.only_malaysia;

      this.e7 = item.value.cat_id;
      // if (item.value.has_atm != "") {
      //   item.value.has_atm;
      //

      // }
      // }
      // console.log(this.cardcardmaster_id, "cardcardmaster_id");
      //this.selectExpense;
    },
    // async getEmpDetails() {
    //   var inputData = {
    //     method_name: "ADMINCUST",
    //     page_no: 1,
    //     record_count: 0,
    //     page_size: null,
    //     app_code: "APORTAL",
    //     method_param: {
    //       action: "CUSTVIEW",
    //       search_text: "",
    //       corp_id: this.$store.getters.get_corpid,
    //       type: "0",
    //     },
    //   };
    //   var responseData = await apiCall(inputData);
    //   //  console.log("responseData", responseData.data.data);
    //   var res = responseData.data.data == null ? [] : responseData.data.data;
    //   res.forEach((element) => {
    //     this.empitems.push({
    //       full_name: element.full_name,
    //       email_id: element.email_id,
    //     });
    //   });
    //   //   console.log("this.empitems", this.empitems);
    // },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    async getDepartList() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GDMASTER",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      this.departmrnts = responseData.data.data;
      //console.log("GETDEPuser", responseData.data.data);
      // this.getbankinfo();
    },
    async assigncardtombr() {
      // console.log("Calling api");
      //  console.log(this.userTypeDestn);
      //  console.log("is_director", this.is_director1);
      // console.log(this.selectPayee1);
      // console.log(this.selectPayee2);
      //  console.log(this.Department.department_id);
      // console.log(this.ispersonalized.user_id);
      // console.log(this.income_amount);
      // console.log(this.ispersonalized);
      // console.log("approverv", this.approverv);
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "MAPUSR",
          first_name:
            this.selectPayee == undefined ||
            this.selectPayee == null ||
            this.selectPayee == ""
              ? ""
              : this.selectPayee,
          middle_name: this.selectPayee1,
          last_name: this.selectPayee2,
          phone_number: this.ContactNumber,
          ccode: "60",
          designation: this.Designation == "" ? null : this.Designation,
          proxy_number: this.proxynumber,
          corp_id: this.$store.getters.get_corpid,
          email_id: this.email_id,
          department_id:
            this.Department.department_id == undefined ||
            this.Department.department_id == null ||
            this.Department.department_id == ""
              ? 0
              : this.Department.department_id,
          ut_id: this.userTypeDestn == "" ? 0 : this.userTypeDestn,
          // ut_id: "0",
          // expense_approver: this.approverv.user_id,
          expense_approver1: this.approverv.user_id,
          expense_approver2: this.approverv2.user_id,
          budget:
            this.income_amount == undefined ||
            this.income_amount == null ||
            this.income_amount == ""
              ? 0
              : this.income_amount,
          dep_budget_id:
            this.Department.dep_budget_id == undefined ||
            this.Department.dep_budget_id == null ||
            this.Department.dep_budget_id == ""
              ? 0
              : this.Department.dep_budget_id,
          cardmaster_id: this.cardcardmaster_id,
          yse_charge_code: this.ysechargecode,
          cardtype: "2",
          sub_cardttype: this.cardrow == "1" ? "1" : "2",
          is_director: this.is_director1,
          cm_comments: this.comments,
        },
      };

      // console.log("inputData", inputData);

      var responseData = await apiCall(inputData);
      // console.log("MAPUSR responseData", responseData);
      this.hideSnackar = true;
      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: "Assigned Card to User Successfully",
          color: "green",
        });

        this.assigncarddialog = false;
        this.assigndialog = false;
        this.$emit("backChild");
        this.$emit("backChildFc");

        this.FName = "";
        this.MName = "";
        this.LName = "";
        this.ContactNumber = "";
        this.Designation = "";
        this.Department = "";
        this.$refs.assignCards.resetValidation();
        this.$refs.assignCards.reset();
        this.$refs.assignCards2.reset();
        this.$refs.assignCards3.reset();
        this.$refs.assignCards.reset();
        this.$refs.assignCards4.reset();
        // this.$refs.assignCards3.reset();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }

      // this.getbankinfo();
    },
  },
};
</script>

<style>
.v-select {
  text-decoration-color: red;
}
</style>
